var ActivityInterface = {
    type:String,
    player:String,
    date: Date,
    link:String,
}
export default ActivityInterface;